import * as Raven from "raven-js";
// import * as LogRocket from 'logrocket';
// import * as createNgrxMiddleware from 'logrocket-ngrx';
import { BrowserModule } from "@angular/platform-browser";
import { ErrorHandler, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { MaterialModule } from "./material/material.module";
import {
  CovalentExpansionPanelModule,
  CovalentLayoutModule,
  CovalentStepsModule,
} from "@covalent/core";

import { routes } from "./app.routes";
import { reducers } from "./core/store/reducers";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { StoreModule } from "@ngrx/store";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { SimpleNotificationsModule } from "angular2-notifications";
import { AuthenticatedGuard } from "@core/guards/authenticated.guard";
import { EffectsModule } from "@ngrx/effects";
import { AuthEffects } from "./core/store/auth/auth.effects";
import {
  AUTHENTICATION_SERVICE,
  AuthenticationService,
} from "@core/store/auth/authentication.service";
import {
  AUTHORIZATION_SERVICE,
  AuthorizationService,
} from "@core/store/auth/authorization.service";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { I18nHttpClient } from "@core/services/i18n-http.service";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { environment } from "../environments/environment";
import { VERSION } from "../environments/version";
import { SubscriptionGuard } from "@core/guards/subscription.guard";
import { AlreadyLoggedGuard } from "@core/guards/already-logged.guard";
import { SettingsEffects } from "@core/store/settings/settings.effects";
import { SharedModule } from "@app/shared/shared.module";
import { ActionTypes } from "@core/store/auth/auth.actions";
import {
  LOCALSTORAGE,
  TokenStorage,
} from "@core/services/token-storage.service";
import { AuthInterceptor } from "@core/services/auth.interceptor";
import { UserEffects } from "@core/store/user/user.effects";
import { UserService } from "@core/store/user/user.service";
import { SettingsModule } from "@app/settings/settings.module";
import { WebpackTranslateLoader } from "@app/webpack-translate-loader";

export class RavenErrorHandler implements ErrorHandler {
  handleError(err: any): void {
    Raven.captureException(err);

    const chunkFailedMessage = /Loading chunk [\d]+ failed/;

    if (chunkFailedMessage.test(err.message)) {
      window.location.reload(true);
      return;
    }

    Raven.showReportDialog();
    console.log(err);
  }
}

export function getLocalStorage() {
  return typeof window !== "undefined" ? window.localStorage : null;
}

declare module "@ngrx/store" {
  interface Action {
    type: string;
    payload?: any;
  }
}

const metaReducers = [];

if (environment.production) {
  /*
    LogRocket.init('wfhiaa/makemeclear');

    const logrocketMiddleware = createNgrxMiddleware(LogRocket);
    metaReducers.push(logrocketMiddleware);
     */

  Raven.config("https://ae120ff866ad48cd94a028fa56970cc7@sentry.io/244292", {
    release: `${VERSION.version}#${VERSION.hash}`,
  }).install();
  /*
        .setDataCallback(function (data) {
            data.extra.sessionURL = LogRocket.sessionURL;
            return data;
        })
         */
}

/* on logout clear store */
function logout(reducer) {
  return function (state, action) {
    if (action.type === ActionTypes.LOGOUT) {
      state = undefined;
    }

    return reducer(state, action);
  };
}
metaReducers.push(logout);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    CovalentLayoutModule,
    CovalentStepsModule,
    CovalentExpansionPanelModule,
    TranslateModule,
    RouterModule.forRoot(routes),
    StoreModule.forRoot(reducers, { metaReducers }),
    !environment.production ? StoreDevtoolsModule.instrument({}) : [],
    SimpleNotificationsModule.forRoot(),
    EffectsModule.forRoot([AuthEffects, SettingsEffects, UserEffects]),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: WebpackTranslateLoader,
        deps: [HttpClient],
      },
    }),
    SharedModule,
    SettingsModule,
  ],
  providers: [
    AuthenticatedGuard,
    AuthenticationService,
    SubscriptionGuard,
    AuthorizationService,
    AlreadyLoggedGuard,
    I18nHttpClient,
    TokenStorage,
    AuthInterceptor,
    UserService,
    {
      provide: ErrorHandler,
      useClass: environment.production ? RavenErrorHandler : ErrorHandler,
    },
    { provide: LOCALSTORAGE, useFactory: getLocalStorage },
    { provide: AUTHENTICATION_SERVICE, useClass: AuthenticationService },
    { provide: AUTHORIZATION_SERVICE, useClass: AuthorizationService },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// /app/src/app/app.module.ts